import { PILL } from 'conversations-internal-schema/widget-data/constants/launcherTypes';
export const getShowPillLauncher = ({
  isAIChatBot,
  launcherType,
  mobile
}) => isAIChatBot && launcherType === PILL && !mobile;